// extracted by mini-css-extract-plugin
export var ImageSlider__Container = "ImageSlider-module--ImageSlider__Container--2S4m4";
export var ImageSlider__Image = "ImageSlider-module--ImageSlider__Image--2RSEi";